"use client";

import styles from "./Input.module.scss";
import classNames from "classnames";
import { InputTypes } from "./Input.types";
import { Fieldset } from "../fieldset";

const Input = ({
  id,
  name,
  label,
  disabled = false,
  readOnly = false,
  required = false,
  className = "",
  placeholder,
  defaultValue = "",
  value,
  startContent = null,
  endContent = null,
  autoFocus = false,
  autoComplete,
  maxLength,
  inputMode,
  onChange,
  size = "medium",
  labelPlacement = "outside",
  type = "text",
  variant = "primary",
  error,
}: InputTypes) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnly) return;
    const next = e.target.value;
    if (onChange) onChange(next);
  };

  return (
    <Fieldset error={error}>
      <div className={classNames(styles["comp"], className)}>
        {label && labelPlacement === "outside" && (
          <label className={styles["comp__label"]} htmlFor={id}>
            <span>{label}</span>
            {required && <span>*</span>}
          </label>
        )}

        <div
          className={classNames(
            styles["comp__container"],
            styles[`comp__container--variant-${error ? "danger" : variant}`],
            styles[`comp__container--size-${size}`],
            disabled && styles["comp__container--disabled"]
          )}
        >
          {startContent && startContent}

          <input
            id={id}
            name={name ?? id}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            maxLength={maxLength}
            inputMode={inputMode}
            onChange={handleChange}
            placeholder={placeholder}
            {...(value !== undefined ? { value } : { defaultValue })}
            className={styles["comp__input"]}
            onWheel={(e: any) => e.target.blur()}
          />

          {endContent && endContent}
        </div>
      </div>
    </Fieldset>
  );
};

export { Input };
